export enum PostType {
  FIX = '⚙️',
  CREATION = '🎨',
  NEW = '📚',
  OPINION = '🤔',
  CONFETTI = '🎊',
}
